module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking@3x.87f919f1.png";